import { Delivery } from "@carbon/icons-react";
import { Button } from "@mui/material";
import { ReactElement } from "react";

import "./FallbackComponent.scss";

interface FallbackComponentProps {
  middleIcon: ReactElement;
  text: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const FallbackComponent = (props: FallbackComponentProps) => {
  const { middleIcon, text, buttonText, onButtonClick } = props;
  const hasButtonProps = !!buttonText && !!onButtonClick;

  return (
    <div className="content">
      <div className="content-container">
        <div className="content-container-icons">
          <div className="content-container-icons-left">
            <Delivery size={20} />
          </div>
          <div className="content-container-icons-middle">{middleIcon}</div>
          <div className="content-container-icons-right">
            <Delivery size={20} />
          </div>
        </div>
        <div className="content-container-text">{text}</div>
      </div>
      {hasButtonProps && (
        <div className="content-button">
          <Button onClick={onButtonClick} variant="outlined">
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default FallbackComponent;
